/**
 * Gate for every `/admin/*` route: Outflanq staff only.
 *
 * The API already refuses a customer (`require_operator`), so this is not the
 * security boundary -- it is there so a customer who types the URL lands back
 * on their own dashboard instead of on a screen full of 403s.
 *
 * Renders nothing while /me is in flight: flashing the admin shell and then
 * redirecting reads as a glitch, and the query is cached app-wide anyway.
 */
import type { ReactNode } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Navigate } from 'react-router-dom';

import { api } from '@/lib/api';

export function RequireOperator({ children }: { children: ReactNode }) {
  const { data, isPending } = useQuery({
    queryKey: ['me'],
    queryFn: () => api.auth.me(),
    staleTime: 300_000,
  });

  if (isPending) return null;
  if (!data?.is_operator) return <Navigate to="/" replace />;
  return <>{children}</>;
}
